<template>
  <div
    :style="{
      backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee',
      padding: '10px',
      // paddingTop: '0px',
      paddingTop: '20px',
      position: 'relative',
      bottom: '20px',
      minHeight: '100vh',
      height: 'auto',
      '--bg-theme': bgTheme
    }"
    id="transactions"
  >
    <div class="padding-top-5"></div>
    <div class="margin-10 box-shadow" style="border-radius: 10px;">
      <div
        :style="{
          backgroundColor: isDarkTheme ? shadowBgColor : '#ffffff',
          borderRadius: '10px'
        }"
        class="bg-light align-ver center-hor"
      >
        <div
          :style="{
            backgroundColor: isDarkTheme ? shadowBgColor : '#ffffff',
            padding: '20px',
            color: 'black',
            borderRadius: '10px '
          }"
          class="align-hor center-ver space-around padding-10 margin-bottom-10 text-uppercase"
        >
          <div
            class="radio custom-radio no-margin pull-left"
            @click="toggleBankUPI(false)"
          >
            <label class="pointer">
              <input
                type="radio"
                class="custom-input-check"
                name="redeem_type"
                id="bank"
                value="bank"
                required
                checked
                :style="
                  !is_upi && isDarkTheme ? { '--radio-color': '#ff0000' } : {}
                "
              />
              Bank
            </label>
          </div>
          <div
            class="radio custom-radio no-margin pull-right"
            @click="toggleBankUPI(true)"
          >
            <label class="pointer">
              <input
                type="radio"
                class="custom-input-check"
                name="redeem_type"
                id="upi"
                value="upi"
                required
                :style="
                  is_upi && isDarkTheme
                    ? { '--radio-color': headingTextColor }
                    : {}
                "
              />
              UPI
            </label>
          </div>
        </div>
        <div style="padding-bottom: 15px; color: black;">
          <div
            :style="{
              backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff'
            }"
            class="bank-details"
            v-if="!is_upi"
          >
            <input
              :style="{
                backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff'
              }"
              class="margin-bottom-10 custom-input w80 fs-16"
              type="number"
              v-model="acNumber"
              placeholder="A/C Number"
            />
            <input
              :style="{
                backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff'
              }"
              class="margin-bottom-10 custom-input w80 fs-16"
              type="text"
              v-model="ifsc"
              placeholder="IFSC"
            />
            <input
              :style="{
                backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff'
              }"
              class="margin-bottom-10 custom-input w80 fs-16"
              type="text"
              v-model="acHolderName"
              placeholder="Account Holder's name"
            />
          </div>
          <div
            :style="{
              backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff'
            }"
            class="upi-details"
            v-else
          >
            <input
              :style="{
                backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
              }"
              class="margin-bottom-10 custom-input w80 fs-16"
              type="text"
              v-model="upiId"
              placeholder="UPI ID"
            />
          </div>
          <div
            style="padding:15px 10px;"
            class="margin-bottom-10 text-regular"
            v-if="reward_bal"
          >
            {{ reward_bal }} will be transferred into above mentioned
            {{ type == "bank" ? type + " account" : type + " ID" }}
          </div>
          <button
            class="custom-button small radius-5 text-uppercase pointer"
            :style="{
              background: isDarkTheme ? buttonBGColor : bgTheme,
              color: isDarkTheme ? headingTextColor : '#ffffff'
            }"
            style="padding: 10px 30px;"
            @click="redeemRequest($event)"
          >
            withdraw
          </button>
        </div>
      </div>
    </div>

    <pan-dialog
      :show="showPanDialog"
      @close="closePanDialog()"
      @success="onPanValidated()"
    />
  </div>
</template>
<script>
import { globals } from "@/mixins/globals";
import axios from "axios";
import { isDate } from "moment";
import PanDialog from "@/components/pan-dialog.vue";
export default {
  mixins: [globals],
  components: { PanDialog },
  data() {
    return {
      type: "bank",
      is_upi: false,
      acNumber: "",
      ifsc: "",
      acHolderName: "",
      upiId: "",
      reward_bal: "",
      showPanDialog: false,
      pendingRedeemEvent: null
    };
  },
  methods: {
    toggleBankUPI(state) {
      if (state == false) {
        this.type = "bank";
      } else {
        this.type = "upi";
      }
      this.is_upi = state;
    },
    redeemRequest(event) {
      var ac_type = this.type;
      var number = this.acNumber;
      var ifsc = this.ifsc;
      var name = this.acHolderName;
      var upi_id = this.upiId;
      var data = { ac_type: ac_type };
      if (ac_type == "bank") {
        if (!number) {
          this.toastPopup(true, "Please enter the valid Account number");
          return false;
        }
        if (!ifsc) {
          this.toastPopup(true, "Please enter the valid IFSC code");
          return false;
        }
        if (!name) {
          this.toastPopup(true, "Please enter the valid Account holder name");
          return false;
        }

        data.number = number;
        data.ifsc = ifsc;
        data.name = name;
      } else if (ac_type == "upi") {
        if (!upi_id) {
          this.toastPopup(true, "Please enter the valid UPI ID");
          return false;
        }
        data.upi_id = upi_id;
      }

      var url = this.$store.getters.flyyDomain + "/transfer_requests";
      var headers = this.$store.getters.headers;

      var options = {
        method: "post",
        url: url,
        headers: headers,
        data: data
      };
      event.target.disabled = true;
      axios(options)
        .then(resp => {
          if (resp.status == 200) {
            if (resp.data.success) {
              this.toastPopup(true, resp.data.message);
              this.back();
            } else if (resp.data.pan_required) {
              event.target.disabled = false;
              this.pendingRedeemEvent = event;
              this.showPanDialog = true;
            } else {
              event.target.disabled = false;
              this.toastPopup(true, resp.data.message);
            }
          } else {
            event.target.disabled = false;
            this.toastPopup(true, resp.data.message);
          }
        })
        .catch(err => {
          event.target.disabled = false;
          console.log("Redemption error!");
        });
    },
    closePanDialog() {
      this.showPanDialog = false;
    },
    onPanValidated() {
      var redeemEvent = this.pendingRedeemEvent;
      this.showPanDialog = false;
      this.pendingRedeemEvent = null;
      if (redeemEvent) {
        this.redeemRequest(redeemEvent);
      }
    }
  },
  created() {
    if (!this.isEmpty(this.$route.query)) {
      this.reward_bal = this.$route.query.bal ? this.$route.query.bal : "";
      console.log("wallate balance =>", this.reward_bal);
    }
    this.$store.state.showHeader = true;
    this.$store.state.showWallet = false;
    this.$store.state.showHistory = false;
    this.$store.state.user.headerBalance.show = false;
    this.$store.state.headTitle = "Redeem";
  },
  computed: {
    isDarkTheme() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null;
    },
    shadowBgColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.shadowBgColor;
      }
      return null;
    },
    buttonBGColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.buttonBGColor
      ) {
        return this.$store.state.sdkEvent.themeColors.buttonBGColor;
      }
      return null;
    },
    headingTextColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null;
    },
    offersCardBgColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null;
    },
    mainBgColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null;
    }
  }
};
</script>
<style>
.fs-16 {
  font-size: 16px;
}
.custom-radio input[type="radio"]:before {
  content: "";
  display: inline-block;
  width: 0.7em;
  height: 0.7em;
  border-radius: 1em;
  box-shadow: 0 0 0 2px #9b9b9b;
  margin: 2px 0px 0 0;
  transition: 0.5s ease all;
}
.custom-radio input[type="radio"]:disabled:before {
  background: #f2f2f2;
  box-shadow: 0 0 0 2px #ebebeb;
}
.custom-radio label input[type="radio"]:checked {
  color: #4a4a4a;
}
/* .custom-radio input[type="radio"]:checked:before {
  background: var(--radio-color, #4a4a4a) !important;
  border-radius: 1em;
  border: 0.18em solid var(--radio-color, #ffffff);
} */
.custom-radio input[type="radio"]:checked:before {
  background: var(--radio-color, var(--bg-theme)) !important;
  border-radius: 1em;
  border: 0.18em solid var(--radio-color, #ffffff);
}

.custom-input::placeholder {
  color: #9f9f9f;
  opacity: 1; /* ensures consistent color across browsers */
}
</style>
